// src/RootListener.jsx
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "./redux/slices/authSlice";
import { applyBrandToDOM } from "./utils/branding";

export default function RootListener() {
  const dispatch = useDispatch();

  useEffect(() => {
    const initialSource = localStorage.getItem("source") || "wayuvega";
    applyBrandToDOM(initialSource);

    const onStorage = (e) => {
      if (!e) return;
      if (e.key === "authToken" && e.oldValue && !e.newValue) {
        dispatch(logout());
      }
      if (e.key === "source") {
        applyBrandToDOM(e.newValue || "wayuvega");
      }
    };

    window.addEventListener("storage", onStorage);

    return () => window.removeEventListener("storage", onStorage);
  }, [dispatch]);

  return null;
}
